define("resources/assignments", function(){
    return [
        {
            category: "Default",
            assignments:[
                {
                    name: "Default Lab",
                    path: "default"
                }
            ]
        },
        {
            category: "Molarity and Density",
            assignments:[
                {
                    name: "Dilution Problem 1",
                    author: "Dave Yaron",
                    description: "Dilution of a glucose solution",
                    path: "MolarityDensity/dilution"
                },
                {
                    name: "Dilution Problem 2",
                    author: "Mike Karabinos",
                    description: "Preparation of a stock solution from a concentrated acid",
                    path: "MolarityDensity/dilution2"
                },
                {
                    name: "Sucrose Problem",
                    author: "Jordi Cuadros and Tim Palucka",
                    description: "Molarity, molality, mass percent, mole fraction? Understanding concentrations",
                    path: "MolarityDensity/sucrose"
                },
                {
                    name: "Making Solutions From Solids",
                    author: "Jordi Cuadros and Mike Karabinos",
                    description: "Making salt solutions at different concentration.",
                    path: "MolarityDensity/salt"
                },
                {
                    name: "Metals Density Problem",
                    author: "Jordi Cuadros and Tim Palucka",
                    description: "Identify metals from their density",
                    path: "MolarityDensity/metals"
                },
                {
                    name: "Liquid Density Problem",
                    author: "Jordi Cuadros and Tim Palucka",
                    description: "Identify a liquid from its density",
                    path: "MolarityDensity/liquid"
                },
                {
                    name: "Alcohol Density Problem",
                    author: "Jordi Cuadros and Tim Palucka",
                    description: "Determine the concentration from the density of the solution",
                    path: "MolarityDensity/alcohol"
                }
            ]
        },
        {
            category: "Stoichiometry and Limiting Reagents",
            assignments:[
                {
                    name: "Jello Problem",
                    author: "Donovan Lange",
                    description: "In this problem, students mix together solutions in an atempt to control their color change",
                    path: "Stoichiometry/jello"
                },
                {
                    name: "Oracle Problem",
                    author: "Donovan Lange",
                    description: "Limiting reagent problem to determine the stoichiometry of a reaction",
                    path: "Stoichiometry/oracle"
                },
                {
                    name: "Oracle Problem 2",
                    author: "Donovan Lange",
                    description: "The limiting reagent problem from above with a more challenging solution",
                    path: "Stoichiometry/oracle2"
                },
                {
                    name: "Textbook Style Limiting Reagents Problems",
                    author: "David Yaron and Mike Karabinos",
                    description: "Solving text-book syle limiting reagent problems using the virtual lab",
                    path: "Stoichiometry/textbook"
                },
                {
                    name: "Open-ended Text Book Style Limiting Reagent Problem",
                    author: "David Yaron",
                    description: "Design an experiment to answer a limiting reagent style problem",
                    path: "Stoichiometry/textbook2"
                },
                {
                    name: "Predicting DNA concentration",
                    author: "Dave Yaron",
                    description: "Predict the results of a limiting reagents problem involving strings of DNA",
                    path: "Stoichiometry/dna"
                },
                {
                    name: "DNA/Dye Problem 2",
                    author: "Dave Yaron",
                    description: "In this limiting reagent excercise, students develop an experiment to determine the concentration of an unlabeled container",
                    path: "Stoichiometry/dna2"
                }
            ]
        },
        {
            category: "Quantitative Analysis",
            assignments:[
                {
                    name: "Unknown Concentration Problem",
                    author: "Mike Karabinos",
                    description: "Determine the concentration of Silver ion in a Silver Nitrate Solution",
                    path: "Quantitative/unknown"
                },
                {
                    name: "Gravimetric Determination of Arsenic",
                    author: "Jordi Cuadros",
                    description: "Determine the amount of arsenic present in soil samples",
                    path: "Quantitative/gravimetric"
                }
            ]
        },
        {
            category: "Chemical Equilibrium",
            assignments:[
                {
                    name: "Cobalt Lab",
                    author: "Bob Belford",
                    description: "An experiment that looks at Cobalt(II) Conplexes & LeChatlier's Principle",
                    path: "Chemical/cobalt"
                },
                {
                    name: "DNA Binding Problem",
                    author: "Dave Yaron",
                    description: "Explore equilibrium constants in biochemical systems",
                    path: "Chemical/dna"
                }
            ]
        },
        {
            category: "Solubility and Solids",
            assignments:[
                {
                    name: "Temperature and the Solubility of Salts",
                    author: "Rob Belford and David Yaron",
                    description: "Examine the solubilites of salts based on temperature",
                    path: "Solubility/temperature"
                },
                {
                    name: "Determining the Solubility Product",
                    author: "Rob Belford and David Yaron",
                    description: "Determine the solubility product constant (Ksp) for various solids",
                    path: "Solubility/determine"
                },
                {
                    name: "Solubility Determination Problem",
                    author: "Dave Yaron",
                    description: "Determine the solubility of CuCl at different temperatures",
                    path: "Solubility/solubilty"
                },
            ]
        },
        {
            category: "Acids and Bases",
            assignments:[
                {
                    name: "Unknown Acid Problem 1",
                    path: "Acids/unknown"
                }

            ]
        },
        {
            category: "Redox",
            assignments:[
                {
                    name: "Redox",
                    path: "Redox/redox"
                }
            ]
        }
    ]
});
